export default {
    newsFiveTitle: "金融科技在拉美的机遇",
    newsTime: "发布时间",
    newsRead: "阅读量",
    newsFiveDetail: [
        {
            p: "这些年以 Nubank 为代表的拉美金融科技逐渐走进人们的视野，3300 万用户，250 亿美金估值的背后是整个拉美金融科技的爆炸式增长，也反映出银行巨头垄断下的拉美在各个金融服务领域都存在大量未被开发的机会，今天我们来探究一下拉美金融科技的前世今生。"
        },
        {
            h4: "拉美金融科技繁荣的内因"
        },
        {
            p: "拉美其实与东南亚在某些方面十分相似，人口都在 6 亿以上，也有两个人口过亿的国家，巴西和墨西哥（人口分别为 2.1 亿和 1.3 亿）。现金仍然是该地区的主要支付手段，在墨西哥大概 90% 的交易仍以现金支付，在巴西则为 70%。"
        },
        {
            p: "拉美金融生态的最大特色之一便是银行长期的金融垄断，以巴西为例，80％ 的存款集中在该国的前五大银行。同时拉丁美洲的大多数银行效率极低，没有相关移动应用程序，无论是取钱还是开户都需要大量的时间成本。"
        },
        {
            p: "垄断使拉美的银行们成为了世界上最赚钱的银行，墨西哥和巴西银行的净资产收益率（ROE）长期保持在 18% 的水平，几乎数倍于欧美等发达国家，这导致了该地区的银行业发展长期停滞不前。"
        },
        {
            h4: "多重因素下的推动"
        },
        {
            p: "上述一系列现象在拉美已经存在了几十年的时间，但随着消费者需求的多样化、移动互联网的渗透、智能手机普及和监管政策的放开都在推动整个金融科技领域向前发展。"
        },
        {
            p: "首先，年轻的人口加上智能手机的普及，为包括金融科技在内的许多行业都提供了无限的可能性，庞大的年轻消费群体期望有更多的金融服务来迎合新时代的需求。当然这个过程中也存在许多尝试和曲折，比如 WhatsApp 在去年 6 月就宣布在其第二大市场巴西启动移动支付业务，然而不到一周就被巴西央行干掉了。"
        },
        {
            p: "其次，拉美各国政府也终于意识到了蛋糕需要做大了才好分，而金融科技是把蛋糕做大的最佳方式。"
        },
        {
            p: "2018 年，墨西哥通过了金融科技法“Ley Fintech”，为金融科技公司拟定了一个框架，以提供全新的金融产品，并要求在与传统金融机构相同的监管下合法运营。Ley Fintech 于今年正式生效，它涵盖了对移动支付、数字钱包、众筹和加密货币的监管。该法还对开放银行和 API 规定了新的规则：传统金融机构必须允许其他金融机构访问其数据，为墨西哥消费者创造更好的产品。"
        },
        {
            p: "墨西哥是拉美国家里最先醒悟的，是首个开放金融技术监管的国家。在此后的几年里，巴西、智利、阿根廷等国家都开始效仿墨西哥，纷纷推出类似的法律，并借助各国已有的实时支付系统，来推动金融科技与拉美传统金融巨头竞争。"
        },
        {
            p: "最后是谁都没有料到的变量——疫情，这无疑又助推了本就处于起跑阶段的拉美金融科技。大量企业倒闭和社会距离限制政策使人们主动去接触数字生活和在线支付，开始尝试新的金融产品和应用程序。"
        },
        {
            p: "同样，疫情也迫使企业调整自己的策略，开始提供网上购物、接受信用卡支付以及与数字平台集成，例如巴西的电商份额在疫情里通过短短十周的时间增长了 5.4%，而这个 5% 的增长在疫情之前，巴西用了 10 年才完成。"
        },
        {
            p: "可以说疫情加速了消费者对数字金融产品的需求，推动了拉美金融科技时代的到来。"
        },
        {
            h4: "拉美金融科技在拉美的机遇"
        },
        {
            p: "1. 综合型玩家"
        },
        {
            p: "就像上文提到的一样，大多数拉美国家的消费者都苦银行垄断久矣，银行巨头们提供的服务范围和质量都十分有限，金融科技的新玩家可以为这些客户开发并提供量身定制的金融服务，例如，没有任何分支机构，也不收取任何管理费和透支费用的数字银行 Chime，除银行产品外，保险、房租物业等垂直领域都是金融科技可以进一步渗透的行业。"
        },
        {
            p: "2. 基础设施"
        },
        {
            p: "完善金融科技生态、提高服务体验是拉美金融科技玩家的一个主要方向，例如在客户背景调查、企业征信、反洗钱等方面提供更好的服务。"
        },
        {
            p: "当前信用欺诈是该拉美金融科技发展的一大挑战。墨西哥是无卡交易欺诈（Card-Not-Present fraud）现象最严重的国家，其次是巴西。据估计，在拉丁美洲创建的新银行账户中，约有 20% 是虚假账户。"
        },
        {
            p: "信用评估的应用在拉美仍处于一个初始阶段，这使得保险业举步维艰，并导致消费者的费率上升。这些都是有待金融科技玩家发掘的领域，并为该地区提供更多创新型的服务。"
        },
        {
            p: "3. B2B"
        },
        {
            p: "除了金融科技之外，拉美其它行业的初创公司数量都呈爆炸性增长。所有这些公司都将需要相关金融服务：工资单、商业信用卡、员工福利解决方案等等。该地区业务的快速数字化也促使现有业务的运营方式和所需服务的数字化转型。拉丁美洲的中小企业不断增长和大公司对数字化转型的需求，都为金融科技玩家提供了广阔的机会。"
        },
        {
            p: "4. 房地产"
        },
        {
            p: "在拉美，房地产交易的透明度低，流程冗长，贷款选择极少。抵押贷款约占墨西哥国内生产总值的 10%，抵押贷款渗透率也远低于美国的 50%。市面上充斥着大量虚假房源和房产信息，对于买卖双方来说，购房和租房都存在着较大的挑战性。如今也出现了像 QuintoAndar、 Loft 这样的初创公司已经希望利用这个市场，简化购房、销售和融资流程。"
        },
        {
            p: "5. 泛拉美拓展"
        },
        {
            p: "相比其他行业的公司，金融科技公司在进行跨区域扩张时往往会面临更多的挑战。除了具有不同的文化规范和语言外，金融科技公司还必须应对不同国家的法规、首选支付方式、货币和基础设施的影响。目前，大多数公司都会先选择了一个核心市场，然后在这个过程中对其业务进行不同程度的本地化以适应国家之间的差异。"
        },
        {
            p: "随着监管政策的简化和基础设施的完善，在一定程度上缓解了这些挑战，我们也看到 Rappi、Creaditas、Nubank 等不同行业的初创企业都在不断地朝整个拉美区域扩张，这同样也会为整个区域的消费者和企业打开金融渠道。"
        },
        

    ]
}